export const VALIDATE_PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

export const VALIDATE_EMAIL_REGEX = /^[^@]+@[^@]+\.[^@]+$/
